import type { MyEventsQuery } from "../../../graphql/event.hooks";
import type { DisplayStatusValue } from "../../../types";

import { DisplayStatus } from "../../../types";

export type { DisplayStatusValue, SortValueType } from "../../../types";
export { DisplayStatus, EventStatusEnum, SortValue } from "../../../types";

export type MyEventsItem = MyEventsQuery["myEvents"]["items"][number];
export type MyEventsData = MyEventsQuery;

export type IEventCard = {
  id: string;
  slug: string;
  cardImagePath: string;
  title: string;
  description: string;
  startDate: string;
  endDate: string;
  location: string;
  isOnline: boolean;
  isRecurring: boolean;
  recurrenceText: string;
  displayStatus: DisplayStatusValue;
  sold: number;
  capacity: number;
  totalIncome: number;
  totalScanned: number;
  totalBooked: number;
  priceRange: string;
  eventCurrency: string;
  views: number;
  showTicketOfficeButton: boolean;
  payments: Array<{ type?: string | null; ticketOfficeType?: number | null }>;
  shouldShowApproveNotice: boolean;
  shouldShowNeedsChangesNotice: boolean;
  isOnceApproved: boolean;
};

export type StatusConfig = {
  key: string;
  count: number;
  dotColor?: string;
  active: {
    containerClass: string;
    textClass: string;
    badgeClass: string;
  };
};

export const STATUS_KEY_TO_DISPLAY: Record<
  string,
  DisplayStatusValue | undefined
> = {
  all: undefined,
  drafts: DisplayStatus.Draft,
  published: DisplayStatus.Approved,
  moderation: DisplayStatus.Moderation,
  finished: DisplayStatus.Finished,
  needs_changes: DisplayStatus.NeedsChanges,
};
